import { getScreenName } from './helper';

import { fireEvent } from './fireEvent';

export const signToUpdateBabyNames = ['?', '/', '#'];

export const removeUnwantedSign = (name) => {
  for (let sign of signToUpdateBabyNames) {
    name = name?.split(sign)?.join('-');
  }
  return name;
};
export const babyNameBranchLink =
  'https://app.mylofamily.com/NUX_FLOW_GROWTH_TRACKER_UTM?utm_source=web&utm_medium=web&utm_campaign=unique_baby_name';

export const downloadAppHandlerBabyName = (type) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    parent: type,
    cta: 'Get Mylo App',
    deeplink_value: babyNameBranchLink,
    support_variable: type,
  });
  window.location.href = babyNameBranchLink;
};

export const fireOpenPopupEvent = (type) => {
  fireEvent({
    category: 'viewed_popup',
    screen_name: getScreenName(),
    page_url: typeof window != 'undefined' ? window.location.href : 'NA',
    parent: type,
    support_variable: type,
  });
};
